/**
 * После `dev:mobile` / preview с PWA в браузере остаётся Workbox-SW на localhost:3000.
 * Он может перехватывать запросы и давать Failed to fetch / чёрный экран, пока dev-сервер ещё не поднялся.
 * В website dev снимаем регистрацию — PWA в этом режиме не используется.
 */
export default defineNuxtPlugin(() => {
  if (!import.meta.dev) return
  if (typeof navigator === 'undefined' || !navigator.serviceWorker) return

  void navigator.serviceWorker
    .getRegistrations()
    .then((regs) => Promise.all(regs.map((r) => r.unregister())))
    .catch(() => {})
})
